module.exports = __webpack_public_path__ + "img/VRP_Logo_NURSING.a0636a96.png";